<!-- Header -->
<div class="sub-header" *ngIf="!isFromModal">
  <div class="container" style="height: 100%;">
    <div class="controls-panel" style="justify-content: flex-end;">
      <!-- Back Button -->
      <button type="button" class="btn btn-rbv default" [routerLink]="['/manage/research/blurbs']"
        [disabled]="loading">
        <i class="fa fa-angle-left"></i>
        Back
      </button>

      <!-- Delete Button -->
      <button type="button" class="btn btn-rbv pull-right marginLeft10" (click)="removeBlurb()" *ngIf="isEditMode"
        [disabled]="loading">
        <i class="fa fa-trash-o"></i>
        Delete
      </button>

      <!-- Convert Button -->
      <button type="button" class="btn btn-rbv pull-right marginLeft10" (click)="convertFootnote()"
        [disabled]="loading">
        <i class="fa fa-retweet"></i>
        Convert
      </button>

      <!-- Save Button -->
      <button type="button" class="btn btn-rbv pull-right marginLeft10" (click)="saveBlurb()" *ngIf="!showConvert"
        [disabled]="!blurbItem.HEADER || !blurbItem.TEXT || loading">
        <i class="fa fa-floppy-o"></i>
        {{isEditMode ? 'Update' : 'Save'}}
      </button>
    </div>
  </div>
</div>

<!-- Container -->
<div class="container" id="blurbNew" [hidden]="loading">
  <div style="margin: 15px 0px;">
    <div class="d-flex marginBottom10">
      <input type="text" required class="form-control" placeholder="Header" name="header"
        [(ngModel)]="blurbItem.HEADER" />
      <button type="button" class="btn btn-rbv pull-right marginLeft10" (click)="openFootnoteModal()">
        <i class="fa fa-plus marginRight5"></i>
        Insert Footnote
      </button>
    </div>

    <!-- <angular-editor id="blurbItem" (ngModelChange)="checkFootnoteOnPaste($event)" [(ngModel)]="blurbItem.TEXT"
      [config]="blurbConfig"></angular-editor> -->
    <quill-editor #editor name="blurbItem" [(ngModel)]="blurbItem.TEXT" [modules]="quillModules"
      (ngModelChange)="checkFootnoteOnPaste($event)"></quill-editor>

    <!-- Footnote List -->
    <div class="footnote-list marginTop15" *ngIf="blurbItem.REFS?.length > 0">
      <div class="footnote">
        <div *ngFor="let note of blurbItem.REFS; let i = index;">
          <div class="item">
            <div class="row">

              <!-- Footnote Code -->
              <div class="column col-md-2">
                <div>{{note.CODE}}</div>
              </div>

              <!-- Footnote Reference -->
              <div class="column col-md-9">
                <div class="removeMargin" [innerHtml]="note.REFERENCE"></div>
              </div>

              <!-- Ibis options -->
              <div class="column end col-md-1 action">
                <i class="fa fa-close removeNote" title="Remove footnote" (click)="removeFootnote(i)"></i>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Modal to add new field -->
<ng-template #footnoteModal>
  <!-- Header -->
  <div class="modal-header">
    <h4 class="modal-title pull-left">Insert Footnote</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeFootnoteModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- Body -->
  <div class="modal-body">
    <!-- Code -->
    <div class="form-group">
      <label>Code</label>
      <input type="text" class="form-control" placeholder="Code" [(ngModel)]="footnote.CODE" disabled required />
    </div>

    <!-- Reference -->
    <div class="form-group">
      <label>Reference</label>
      <input type="text" class="form-control" placeholder="Reference" [(ngModel)]="footnote.REFERENCE"
        (keyup.enter)="insertFootnote()" required />
    </div>
  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <button class="btn btn-rbv" [disabled]="!footnote.CODE || footnote.CODE === 'FT_' || !footnote.REFERENCE"
      (click)="insertFootnote()">
      Insert
    </button>
  </div>
</ng-template>

<!-- Modal footer (Used when it is open in modal)-->
<div class="customModalFooter" *ngIf="isFromModal">
  <!-- Convert Button -->
  <button type="button" class="btn btn-rbv" (click)="convertFootnote()">
    <i class="fa fa-retweet"></i>
    Convert
  </button>

  <!-- Delete Button -->
  <button type="button" class="btn btn-rbv marginLeft10" (click)="removeBlurb()" *ngIf="isEditMode">
    <i class="fa fa-trash-o"></i>
    Delete
  </button>

  <!-- Save Button -->
  <button type="button" [disabled]="!blurbItem.HEADER || !blurbItem.TEXT" class="btn btn-rbv marginLeft10 f-right" (click)="saveBlurb()" *ngIf="!showConvert">
    <i class="fa fa-floppy-o"></i>
    {{isEditMode ? 'Update' : 'Save'}}
  </button>

  <!-- Cancel Button -->
  <button type="button" class="btn btn-rbv f-right" (click)="closeOuterModal(true)">
    Cancel
  </button>
</div>

<!-- Loader -->
<app-loader [loading]="loading"></app-loader>
